import { IState } from '../../store';
import { selectOfferChatId } from './selectOfferChatId';

export const selectIsOfferChatExists = (state: IState): boolean => {
  const chatId = selectOfferChatId(state);

  return !!chatId;
};
